import { render, staticRenderFns } from "./file-overview.vue?vue&type=template&id=63d7f8be&scoped=true&"
import script from "./file-overview.vue?vue&type=script&lang=ts&"
export * from "./file-overview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d7f8be",
  null
  
)

export default component.exports